interface IUserRight {
  right: 1 | 2 | 3 | 4;
  label: string;
}

export const usersRights: IUserRight[] = [
  {
    right: 1,
    label: 'FUNCIONÁRIO ALUTAL',
  },
  {
    right: 2,
    label: 'QR CODE e PEDIDOS',
  },
  {
    right: 3,
    label: 'QR CODE',
  },
  {
    right: 4,
    label: 'PEDIDOS, QR CODE e CERTIFICADOS',
  },
];

export const getRightLabel = (value: 1 | 2 | 3 | 4): string | undefined => {
  return usersRights.find(userRight => userRight.right === value)?.label;
};

export const getRightNumber = (label: string): 1 | 2 | 3 | 4 | undefined => {
  return usersRights.find(userRight => userRight.label === label)?.right;
};
